import React, { createContext, useContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import { useSelector } from 'react-redux';
import { useNotifications } from './NotificationsContext';
// import { useNavigate } from 'react-router-dom';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const profile = useSelector(state => state.auth.profile);
  const socketURL = require('../utils/Utils').default.socketURL;
  const { addNotification, fetchNotifications } = useNotifications();
  // const navigate = useNavigate();

  const connectSocket = (url, userId) => {
    console.log("Connecting to socket with URL:", url, "and userId:", userId);
    if (socket && socket.connected) return;
    const newSocket = io(url);
    newSocket.on('connect', () => {
      setTimeout(() => {
        newSocket.emit('addUser', userId);
      }, 1000);
    });
    setSocket(newSocket);
  };

  const disconnectSocket = () => {
    if (socket) {
      socket.disconnect();
      setSocket(null);
    }
  };

  useEffect(() => {
    if (isLoggedIn && profile && profile._id) {
      connectSocket(socketURL, profile._id);
    } else {
      disconnectSocket();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, profile]);

  useEffect(() => {
    if (socket) {
      const planChangeHandler = _ => {
        console.log("Plan change detected, reloading messages page.");
        // navigate('/messages');
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      };
      socket.on('planChange', planChangeHandler);

      const notificationHandler = (notification) => {
        console.log('Received notification from socket:', notification);
        addNotification(notification);
      };
      socket.on('notification', notificationHandler);

      // Refresh notifications list when server requests full sync
      const refreshNotificationsHandler = () => {
        console.log('Received refreshNotifications event, fetching notifications...');
        fetchNotifications();
      };
      socket.on('refreshNotifications', refreshNotificationsHandler);

      return () => {
        socket.off('planChange', planChangeHandler);
        socket.off('notification', notificationHandler);
        socket.off('refreshNotifications', refreshNotificationsHandler);
      };
    }
  }, [socket, addNotification, fetchNotifications]);

  return (
    <SocketContext.Provider value={{ socket, connectSocket, disconnectSocket }}>
      {children}
    </SocketContext.Provider>
  );
};
